module.exports = __webpack_public_path__ + "static/media/orthodoxy-3.81a7e69b.jpg";